module.exports = __webpack_public_path__ + "static/background-02aa055bf461864577e8c1f82ea6b8cf.png";